import React from 'react';
import { Phone, Mail, MapPin, ExternalLink, Facebook, Building2, Clock } from 'lucide-react';

const Kontakt = () => {
  const mapyLink = 'https://mapy.com/cs/letecka?source=firm&id=12997156&ds=1&x=16.9278207&y=49.9005471&z=18';
  const facebookLink = 'https://www.facebook.com/piskacpostrelmov';
  
  return (
    <section className="py-16 px-4 bg-gray-800 text-white min-h-screen" data-testid="kontakt-section">
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-12">
          <Phone className="w-16 h-16 mx-auto text-blue-400 mb-4" />
          <h2 className="text-4xl font-bold mb-4">Kontakt</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            V případě jakýchkoliv dotazů nás neváhejte kontaktovat na e-mailové adrese:{' '}
            <a href="mailto:piskacpostrelmov@seznam.cz" className="text-blue-400 hover:underline">
              piskacpostrelmov@seznam.cz
            </a>
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-8 mb-8">
          {/* LEVÁ STRANA - Mapa */}
          <div className="bg-gray-700 rounded-lg p-6">
            <h3 className="text-2xl font-bold mb-4">Kde nás najdete</h3>
            
            <a 
              href={mapyLink}
              target="_blank"
              rel="noopener noreferrer"
              className="block rounded-lg overflow-hidden border-2 border-gray-600 hover:border-blue-400 transition-colors group"
              data-testid="map-link"
            >
              <div className="relative">
                <iframe
                  title="Mapa Pískač Postrelmov"
                  src="https://www.openstreetmap.org/export/embed.html?bbox=16.9258%2C49.8985%2C16.9298%2C49.9025&layer=mapnik&marker=49.9005471%2C16.9278207"
                  className="w-full h-80 pointer-events-none"
                  frameBorder="0"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="bg-blue-600 text-white px-4 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-2 font-semibold shadow-lg">
                    <ExternalLink className="w-4 h-4" />
                    Otevřít v Mapy.cz
                  </div>
                </div>
              </div>
            </a>

            <a
              href={mapyLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-semibold"
            >
              <ExternalLink className="w-4 h-4" />
              Zobrazit na Mapy.cz (letecký pohled)
            </a>
          </div>

          {/* PRAVÁ STRANA - Kontaktní údaje */}
          <div className="bg-gray-700 rounded-lg p-6 space-y-6">
            {/* Adresa */}
            <div className="flex items-start gap-4">
              <MapPin className="w-6 h-6 text-blue-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-xl font-bold text-white">Pískáč Postřelmov</p>
                <p className="text-gray-300 mt-1">Vyhnálovská 693, 78969 Postřelmov, Česko</p>
              </div>
            </div>

            <div className="border-t border-gray-600"></div>

            {/* Předseda */}
            <div className="flex items-start gap-4">
              <Phone className="w-6 h-6 text-blue-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-lg font-semibold text-white">
                  Bc. Bohumil Seidl <span className="text-gray-400 text-sm font-normal">(předseda)</span>
                </p>
                <a href="tel:+420605734830" className="text-xl text-gray-200 hover:text-blue-400 transition-colors">
                  +420 605 734 830
                </a>
              </div>
            </div>

            {/* Místopředseda */}
            <div className="flex items-start gap-4">
              <Phone className="w-6 h-6 text-blue-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-lg font-semibold text-white">
                  Miroslav Mrákava <span className="text-gray-400 text-sm font-normal">(místopředseda)</span>
                </p>
                <a href="tel:+420728683827" className="text-xl text-gray-200 hover:text-blue-400 transition-colors">
                  +420 728 683 827
                </a>
              </div>
            </div>

            {/* Hodiny volání */}
            <div className="flex items-center gap-3 bg-gray-800 rounded-lg px-4 py-3">
              <Clock className="w-5 h-5 text-yellow-400 flex-shrink-0" />
              <p className="text-gray-200 font-semibold">Volat od 11:00 do 23:00 hod.</p>
            </div>

            <div className="border-t border-gray-600"></div>

            {/* Email */}
            <div className="flex items-start gap-4">
              <Mail className="w-6 h-6 text-blue-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm text-gray-400">Email</p>
                <a href="mailto:piskacpostrelmov@seznam.cz" className="text-lg text-gray-200 hover:text-blue-400 transition-colors">
                  piskacpostrelmov@seznam.cz
                </a>
              </div>
            </div>

            {/* Facebook */}
            <div className="flex items-start gap-4">
              <Facebook className="w-6 h-6 text-blue-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm text-gray-400">Facebook</p>
                <a 
                  href={facebookLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg text-gray-200 hover:text-blue-400 transition-colors underline"
                  data-testid="facebook-link"
                >
                  Pískáč Postřelmov
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Doručovací adresa */}
        <div className="bg-gray-700 rounded-lg p-6">
          <div className="flex items-center gap-3 mb-4">
            <Building2 className="w-6 h-6 text-blue-400" />
            <h3 className="text-2xl font-bold">Doručovací adresa</h3>
          </div>
          <div className="text-gray-200 space-y-1 pl-9">
            <p className="text-lg font-semibold">AVZO TSČ ČR Postřelmov p.s.</p>
            <p>Základní organizace Postřelmov</p>
            <p>Vyhnálovská 693</p>
            <p>Postřelmov 789 69</p>
            <p className="pt-2 text-gray-400">
              <span className="font-semibold">IČO:</span> 16626826
            </p>
          </div>
        </div>

        <div className="mt-12 text-center text-gray-400">
          <p>© Pískáč Postřelmov. Všechna práva vyhrazena.</p>
        </div>
      </div>
    </section>
  );
};

export default Kontakt;
